import { Flex, Table, Tbody, Td, Th, Thead, Tr, Typography } from '@aloft/toolkit-sui';

import { selectComparableSalesChartData } from '../../redux/features/selectors/selectComparableSalesChartData.ts';
import { useAppSelector } from '../../redux/hooks.ts';

export function ComparableSalesChart() {
  const chartData = useAppSelector(selectComparableSalesChartData);
  return (
    <Flex flexDirection="column">
      <Typography variant="h3">Comparable Sales</Typography>
      <Table className="comparable-sales-chart">
        <Thead>
          <Tr>
            <Th></Th>
            {chartData.map((data) => (
              <Th key={data.header}>
                <Typography variant="h5">{data.header}</Typography>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>
              <Typography variant="h5">DOM</Typography>
            </Td>
            {chartData.map((data) => (
              <Td key={data.header}>
                <Typography variant="body2">{data.DOM?.toString() ?? ''}</Typography>
              </Td>
            ))}
          </Tr>
          <Tr>
            <Td>
              <Typography variant="h5">Original List Price</Typography>
            </Td>
            {chartData.map((data) => (
              <Td key={data.header}>
                <Typography variant="body2">{data.originalListPrice ?? ''}</Typography>
              </Td>
            ))}
          </Tr>
          <Tr>
            <Td>
              <Typography variant="h5">Close Price</Typography>
            </Td>
            {chartData.map((data) => (
              <Td key={data.header}>
                <Typography variant="body2">{data.closePrice ?? ''}</Typography>
              </Td>
            ))}
          </Tr>
          <Tr>
            <Td>
              <Typography variant="h5">SP as % LP</Typography>
            </Td>
            {chartData.map((data) => (
              <Td key={data.header}>
                <Typography variant="body2">
                  {data.salePriceAsPercentageOfListPrice ?? ''}
                </Typography>
              </Td>
            ))}
          </Tr>
        </Tbody>
      </Table>
    </Flex>
  );
}
